import { gql } from '../../gql-tag';

export const GET_USER_IDS_BY_TEAM_ID = gql(`
  query userIdsByTeamId($teamId: String!) {
    userIdsByTeamId(teamId: $teamId)
  }
`);
